module.exports = __webpack_public_path__ + "static/media/wrl2.png.c03a5249.jpg";